import { render, staticRenderFns } from "./Indices.vue?vue&type=template&id=4c6757de&"
import script from "./Indices.vue?vue&type=script&lang=js&"
export * from "./Indices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports